<script setup lang="ts">
	import { computed } from 'vue'

	import RoomEntry from '@/modules/hotels/components/RoomEntry.vue'
	import { Hotel, Room } from '@/modules/hotels/interfaces/hotelDetailsResponse'

	import { HotelImages } from '../interfaces/hotelImages'

	interface Props {
		roomsList: Room[]
		hotel: Hotel
		hotelImages: HotelImages
		expandRooms: boolean
		modals: {
			[key: string]: { open: (index: number) => void; close: () => void }
		}
	}

	interface Emits {
		(event: 'toggleExpandRooms'): () => void
	}

	const props = defineProps<Props>()
	defineEmits<Emits>()

	const imageUrl = computed(() => {
		const { firstExteriorImage, availableCategories } = props.hotelImages
		if (firstExteriorImage?.url) {
			return firstExteriorImage.url
		}

		if (
			availableCategories.length > 0 &&
			availableCategories[0].images.length > 0
		) {
			return availableCategories[0].images[0].url
		}

		return undefined
	})
</script>

<template>
	<TransitionGroup
		name="list"
		:class="['grid gap-3 sm:gap-4 md:gap-5']"
		tag="ul"
	>
		<li
			v-for="(room, roomIndex) in roomsList.slice(0, 4)"
			:key="room.bookingCode"
			class="relative"
		>
			<RoomEntry
				:room="room"
				:hotel="hotel"
				:modals="modals"
				:index="roomIndex"
				:img-url="imageUrl"
			/>
		</li>
	</TransitionGroup>

	<TransitionGroup
		v-if="expandRooms"
		name="list"
		:class="['grid gap-3 sm:gap-4 md:gap-5 ']"
		tag="ul"
	>
		<li
			v-for="(room, roomIndex) in roomsList.slice(4)"
			:key="room.bookingCode"
			class="relative"
		>
			<RoomEntry
				:room="room"
				:hotel="hotel"
				:modals="modals"
				:index="roomIndex"
				:img-url="hotelImages.firstExteriorImage?.url"
			/>
		</li>
	</TransitionGroup>

	<button
		v-if="roomsList.slice(4).length"
		class="transition-color ml-auto flex items-center text-blue-600 duration-300 hover:text-blue-800"
		@click="$emit('toggleExpandRooms')"
	>
		<span>{{
			expandRooms ?
				'Mostrar menos tarifas'
			:	`Mostrar ${roomsList.slice(4).length} tarifas más`
		}}</span>
		<span :class="['material-symbols-outlined', expandRooms && 'rotate-180']">
			expand_more
		</span>
	</button>
</template>

<style scoped>
	.list-move {
		transition: transform 0.5s ease;
	}
	.list-enter-active,
	.list-leave-active {
		transition: all 0.5s ease;
	}
	.list-enter-from {
		opacity: 0;
		transform: translateY(30px);
	}
	.list-leave-to {
		opacity: 0;
		transform: translateX(-30px);
	}
</style>
